import React from "react"
import { Headline, CTA, GridLines } from "@shared"
import { css } from "@jsUtils"
import { CONTENT } from "@data"

import { PageSection } from "../PageSection"

import Styles from "./careerContent.module.scss"

const { CAREERS } = CONTENT
const { JOINUS } = CAREERS
const { cta, headline1, headline2 } = JOINUS
/**
 * Join Us section
 * @param {object} props - React props
 */
const CareerContent = props => {
  const { color, theme, job } = props
  const [ready, setReady] = React.useState(false)
  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <div className={Styles.content}>
        <Headline size={1} className={Styles.headline}>
          Career
        </Headline>
        <Headline size={5} className={Styles.subhead}>
          {job.title}
        </Headline>
        <p>{job.description}</p>
        <Headline size={5} className={Styles.subhead}>
          Requirements:
        </Headline>
        <p>{job.requirements}</p>
      </div>
    </PageSection>
  )
}

export default CareerContent
